import React from 'react';
import Checkbox from './Checkbox';

import styles from './ChooseMany.module.css';

export interface ChoiceItem {
  id: number;
  label: string;
  checked: boolean;
}

interface ChooseManyProps {
  choiceItems: ChoiceItem[];
  onChange: (choiceId: number, newValue: boolean) => void;
}

const ChooseMany: React.FunctionComponent<ChooseManyProps> = ({ choiceItems, onChange }) => (
  <ul className={styles.chooseManyContainer}>
    {choiceItems.map((e) => {
      const choiceId = e.id;
      const chooseManyStyles = `${styles.chooseManyCheckbox}${
        e.checked ? ` ${styles.checked}` : ''
      }`;
      return (
        <li className={chooseManyStyles} key={`choose-many-${e.id}`}>
          <Checkbox
            id={e.id}
            label={e.label}
            onClick={(nv) => onChange(choiceId, nv)}
            checked={e.checked}
          />
        </li>
      );
    })}
  </ul>
);

ChooseMany.displayName = 'ChooseMany';

export default ChooseMany;
